import { z } from "zod/v4";

import { AnalyticsProductDtoSchema } from "@intelligems/ig-types/dtos/analytics-products";
import { S3FileLocationDtoSchema } from "@intelligems/ig-types/dtos/s3-file-location";

export const IAnalyticsProductsStateSchema = z.object({
  isSuccess: z.boolean(),
  analyticsProducts: AnalyticsProductDtoSchema.array(),
  storedAnalyticsProducts: AnalyticsProductDtoSchema.array(),
  productsLocation: S3FileLocationDtoSchema.nullish(),
  isFetching: z.boolean(),
  isLoading: z.boolean(),
});

export type IAnalyticsProductsState = z.infer<
  typeof IAnalyticsProductsStateSchema
>;

export const sliceInitialAnalyticsProductsState: IAnalyticsProductsState = {
  isSuccess: false,
  analyticsProducts: [],
  storedAnalyticsProducts: [],
  isFetching: false,
  isLoading: false,
};
